<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M10 3.2c-2.5 0-4 1.8-4 4.2 0 3.4-1.2 4.3-1.2 4.3h10.4S14 10.8 14 7.4c0-2.4-1.5-4.2-4-4.2zM8.6 14.4a1.6 1.6 0 0 0 2.8 0"/></svg>
</template>
